import { FC, ReactNode } from 'react';

import { ListContext, ListItemState } from './ListContext';

type ListProviderProps = {
  children: ReactNode;
  value?: ListItemState;
};

export const ListProvider: FC<ListProviderProps> = ({ children, value }) => (
  <ListContext.Provider value={value}>{children}</ListContext.Provider>
);
